module.exports = __webpack_public_path__ + "static/media/SOS.3b3c6dd2.png";